
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */



const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
<h1>{`Layout`}</h1>
<p>{`Here you'll find some code snippets and other information about how to organise pages following the Drawbotics UI guidelines.`}</p>
<h3>{`Reponsiveness`}</h3>
<p>{`For enabling responsive UIs in the pages we create, you have some options available to you:`}</p>
<ul>
<li parentName="ul"><inlineCode parentName="li">{`useScreenSize`}</inlineCode></li>
<li parentName="ul">{`The `}<inlineCode parentName="li">{`responsive`}</inlineCode>{` component prop`}</li>
</ul>
    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;